
      var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTv = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1.65,
  y: 2.65,
  width: 12.7,
  height: 8.7,
  rx: 1.491,
  stroke: "#000",
  strokeWidth: 1.3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.844 8.791a.28.28 0 0 0 .286-.002l2.431-1.475a.291.291 0 0 0 .14-.25.291.291 0 0 0-.14-.248L7.131 5.34a.28.28 0 0 0-.287-.003.29.29 0 0 0-.144.252v2.95c0 .104.055.2.144.251z",
  fill: "var(--theme-primary, #810ea9)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 13,
  width: 8,
  height: 1.3,
  rx: 0.65,
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <rect x=\"1.65\" y=\"2.65\" width=\"12.7\" height=\"8.7\" rx=\"1.491\" stroke=\"#000000\" stroke-width=\"1.3\"/>\r\n    <path d=\"M6.844 8.791a.28.28 0 0 0 .286-.002l2.431-1.475a.291.291 0 0 0 .14-.25.291.291 0 0 0-.14-.248L7.131 5.34a.28.28 0 0 0-.287-.003.29.29 0 0 0-.144.252v2.95c0 .104.055.2.144.251z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <rect x=\"4\" y=\"13\" width=\"8\" height=\"1.3\" rx=\".65\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/tv.afe770297182dcfc227f0ab1a221066f.svg"),
        {
          React: SvgTv,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      